import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface VesselProps {
  children: ReactNode;
  image: string;
  name: string;
}

const Vessel = ({ children, image, name }: VesselProps) => (
  <Card sx={{ overflow: 'visible' }}>
    <CardContent>
      <Typography component="h3" variant="h6" gutterBottom>
        {name}
      </Typography>
      <Box
        component="img"
        src={image}
        sx={{ borderRadius: 2, backgroundColor: 'rgba(51, 73, 115, 0.3)', p: 2 }}
        width="100%"
      />
    </CardContent>
    {children}
  </Card>
);

export default Vessel;
